import React from "react";
import { Routes as Router, Route } from "react-router-dom";
import Loader from "react-js-loader";

const HomePage = React.lazy(() => import('./pages/Home/Home'));
const AboutPage = React.lazy(() => import('./pages/About/About'));
const MemberShipPage = React.lazy(() => import('./pages/MemberShip/MemberShip'));
const ReferralProgramPage = React.lazy(() => import('./pages/ReferralProgram/ReferralProgram'));
const FaqPage = React.lazy(() => import('./pages/Faq/Faq'));
const LoginPage = React.lazy(() => import('./pages/Login/Login'));
const LoginBEPage = React.lazy(() => import('./pages/LoginBe/LoginBe'))
const RegisterPage = React.lazy(() => import('./pages/Register/Register'));
const ForgotPasswordPage = React.lazy(() => import('./pages/ForgotPassword/ForgotPassword'));
const DashboardPage = React.lazy(() => import('./pages/Dashboard/Dashboard'));
const BookNowPage = React.lazy(() => import('./pages/BookNow/BookNow'));
const WithdrawPage = React.lazy(() => import('./pages/Withdraw/Withdraw'));
const DepositPage = React.lazy(() => import('./pages/Deposit/Deposit'));
const HistoryPage = React.lazy(() => import('./pages/BookingHistory/BookingHistory'));
const TransactionHistoryPage = React.lazy(() => import('./pages/TransactionHistory/TransactionHistory'));
const SettingPage = React.lazy(() => import('./pages/Setting/Setting'));

export default function Routes() {
  return (
    <React.Suspense fallback={
      <div style={{
        display: 'flex',
        height: "100vh",
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Loader type="bubble-loop" bgColor={"var(--primary-color)"} size={50} />
      </div>}>
      <Router>
        <Route exact path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/membership" element={<MemberShipPage />} />
        <Route path="/referral-program" element={<ReferralProgramPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path='/login_be/:hash' element={<LoginBEPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/book-now" element={<BookNowPage />} />
        <Route path="/withdraw" element={<WithdrawPage />} />
        <Route path="/deposit" element={<DepositPage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/transaction-history" element={<TransactionHistoryPage />} />
        <Route path="/setting" element={<SettingPage />} />

        {/* <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/setting" element={<SettingPage />} />
        <Route path="/kiosk" element={<KioskPage />} />
        <Route path="/reception-counter-table" element={<ReceptionCounterPage />} /> */}
        {/* <Route path="/reception-member-profile/:appointment_id" element={<RCMemberProfilePage />} /> */}
      </Router>
    </React.Suspense>
  );
}
